import React from "react";
import HoursAllocation from "./HoursAllocation.jsx";
import { consolidationRequest } from "../../api/consolidationApi.js";
import { preloadKey } from "../../utils/consolidationPreloadBatch.js";

// Les soirées validées gardent leurs calculs figés ; les brouillons utilisent le calcul serveur de validation.
export default function PreloadHoursAllocation({ saved, rows, day, employeeId, executionDate, resultsHidden, side }) {
  const [attempt, retry] = React.useReducer(value => value + 1, 0);
  const [result, setResult] = React.useState(null);
  const frozen = rows.every(row => row.validated_calculation);
  const body = saved && !frozen ? { employee_id: employeeId, execution_date: executionDate, delivery_date: day,
    version: saved.version, day_version: rows[0]?.day_version } : null;
  const key = JSON.stringify([body, rows.map(row => [row.id, row.version, row.shared_versions]), attempt]);
  React.useEffect(() => {
    if (!body || resultsHidden) return undefined;
    const controller = new AbortController();
    consolidationRequest("/preload-services/preview", { method: "POST", body, signal: controller.signal })
      .then(calculation => { if (!controller.signal.aborted) setResult({ key, calculation }); })
      .catch(error => { if (!controller.signal.aborted) setResult({ key, error: error.message }); });
    return () => controller.abort();
  }, [key, resultsHidden]);
  const calculation = frozen ? { format_version: 2,
    excluded_seconds: rows.reduce((sum, row) => sum + Number(row.validated_calculation.excluded_seconds || 0), 0),
    charges: rows.flatMap(row => row.validated_calculation.charges.map(charge => ({ ...charge,
      key: `${preloadKey(row)}:${charge.key}`, visit_id: preloadKey(row) }))) }
    : result?.key === key ? result.calculation : null;
  const sheet = { ...saved, dispatch_date: day, visits: rows.map(row => ({ id: preloadKey(row), orders: row.links })) };
  return <HoursAllocation preloadEvening side={side} sheet={sheet} calculation={calculation}
    pending={Boolean(body && !resultsHidden && result?.key !== key)} resultsHidden={resultsHidden}
    awaitingInput={!saved && !frozen} error={result?.key === key ? result.error : null} onRetry={retry} />;
}
